<table class="row-group-table w-full border-separate border-spacing-y-2">
  <thead>
    <tr>
      <th
        *ngFor="let column of tableColumns; let i = index"
        class="border-0 text-left text-[12px] font-normal text-[#666666] bg-transparent px-[0.857rem] py-[0.5rem]"
        [ngClass]="
          i !== 0
            ? 'col-minwidth ' + column.value + '-th'
            : column.value + '-th'
        "
        [hidden]="column?.disabled && column.value !== 'check_box'"
      >
        <ng-container *ngIf="column.value === 'check_box' && !column?.disabled">
          <span class="flex gap-2 items-center">
            <p-checkbox
              [binary]="true"
              [ngModel]="isAllRowsSelected()"
              [ngClass]="{ 'p-checkbox-indeterminate': isSomeRowsSelected() }"
              (onChange)="toggleAllSelection($event.checked)"
            ></p-checkbox>
          </span>
        </ng-container>
        <ng-container *ngIf="column.value !== 'check_box'">
          <span
            class="flex items-center justify-start gap-2"
            [class.cursor-pointer]="column.sortable"
            (click)="column.sortable && toggleSort(column)"
          >
            <span>{{ column.label | translate }} </span>

            <span class="custom-sort-icon" *ngIf="column.sortable">
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-arrow-sort-normal.svg"
                *ngIf="!isSortedColumn(column)"
              />
              <img
                src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-arrow-sort.svg"
                *ngIf="isSortedColumn(column)"
                [ngClass]="{
                  asc: isAscending(column),
                  desc: isDescending(column),
                }"
              />
            </span>
          </span>
        </ng-container>
      </th>
    </tr>

    <!-- Filters Row -->
    <tr class="filters-row" *ngIf="showFilters">
      <th
        *ngFor="let column of tableColumns"
        [hidden]="column?.disabled && column.value !== 'check_box'"
        class="border-0 bg-transparent px-[0.857rem] py-[0.25rem]"
      >
        <ng-container *ngIf="column?.value !== 'action' && !column?.disabled">
          <input
            *ngIf="column?.filterType === 'input_text'"
            type="text"
            class="w-full rounded border border-[#e5e7eb] bg-white px-2 py-1 text-[11px] text-[#333333] focus:outline-none"
            [placeholder]="column.label ? (column.label | translate) : ('SHARED.TYPE_HERE' | translate)"
            (keyup)="filterSearch($any($event.target).value, column)"
          />

          <ng-select
            *ngIf="
              column?.filterType === 'dropdown' && column?.filterOptions?.length
            "
            [items]="column.filterOptions"
            [multiple]="true"
            bindLabel="label"
            bindValue="value"
            [(ngModel)]="column.selectedFilterValues"
            [placeholder]="('ADMIN.SELECT' | translate) + ' ' + (column.label ? (column.label | translate) : ('ADMIN.OPTION' | translate))"
            [closeOnSelect]="false"
            [searchable]="false"
            [clearable]="false"
            appendTo="body"
            (change)="onNgSelectChange(column.selectedFilterValues, column)"
            class="filter-dropdown"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-item$="item$"
            >
              <input type="checkbox" [checked]="item$.selected" readonly />
              {{ item.label }}
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items"></ng-template>
          </ng-select>

          <div
            *ngIf="['created_at', 'updated_at'].includes(column?.value)"
            class="eda-datepicker date-filter-item calendar-wrapper"
          >
            <p-calendar
              class="eda-calendar filter-date-range"
              #edaCalendar
              [ngModel]="
                dateFilterApplied[column?.value]?.dateRange?.length
                  ? dateFilterApplied[column?.value]?.dateRange
                  : null
              "
              [ngModelOptions]="{ standalone: true }"
              view="month"
              dateFormat="M-yy"
              [readonlyInput]="true"
              inputId="pickmonth"
              [showIcon]="true"
              [hideOnDateTimeSelect]="false"
              appendTo="body"
              selectionMode="range"
              placeholder="Select Date"
              [disabled]="
                !(totalItems > 0) && !dateFilterApplied[column?.value]?.isDirty
              "
              (onClickOutside)="handleClickOutside(edaCalendar, column?.value)"
            >
              <ng-template pTemplate="footer">
                <div class="calendar-footer">
                  <button
                    class="btn btn-primary btn-sm apply"
                    (click)="
                      applyDateFilter(edaCalendar?.value, column?.value);
                      edaCalendar.hideOverlay()
                    "
                    [disabled]="
                      isDatesSelected(edaCalendar?.value) ||
                      (!(totalItems > 0) &&
                        !dateFilterApplied[column?.value]?.isDirty)
                    "
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-secondary btn-sm reset"
                    (click)="resetCalendar(column?.value, edaCalendar)"
                    [disabled]="
                      !(totalItems > 0) &&
                      !dateFilterApplied[column?.value]?.isDirty
                    "
                  >
                    Reset
                  </button>
                </div>
              </ng-template>
            </p-calendar>
          </div>
        </ng-container>
      </th>
    </tr>
  </thead>

  <tbody>
    <ng-template #groupRow let-node let-level="level">
      <tr>
        <td
          [attr.colspan]="tableColumns.length"
          class="bg-white rounded-md px-2 py-0 shadow-[0_0_15px_rgba(0,0,0,0.1)]"
        >
          <div
            class="group-header-box flex items-center gap-[8px] py-[9px] pr-0 pl-2 text-xs font-semibold text-black"
            [ngClass]="'level-' + level"
          >
            <button
              type="button"
              class="mt-[3px]"
              (click)="toggleNodeExpand(node); $event.stopPropagation()"
            >
              <i
                class="pi text-[13px] text-gray-500"
                [ngClass]="
                  isNodeExpanded(node) ? 'pi-angle-down' : 'pi-angle-right'
                "
              ></i>
            </button>

            <ng-container *ngIf="isSelectionColumnEnabled()">
              <p-checkbox
                [binary]="true"
                [ngModel]="isGroupSelected(node)"
                [ngClass]="{
                  'p-checkbox-indeterminate': isGroupPartiallySelected(node),
                }"
                (onChange)="toggleGroupSelection(node, $event.checked)"
              ></p-checkbox>
            </ng-container>

            <span class="capitalize">{{ getGroupLabel(node) }} </span>
          </div>

          <ng-container *ngIf="isNodeExpanded(node)">
            <table
              class="w-full border-separate border-spacing-y-2 ml-0 pl-0 pr-0"
              *ngIf="getChildGroups(node).length"
            >
              <tbody>
                <ng-container
                  *ngFor="
                    let child of getChildGroups(node);
                    trackBy: trackRowKey
                  "
                >
                  <ng-container
                    *ngTemplateOutlet="
                      groupRow;
                      context: { $implicit: child, level: level + 1 }
                    "
                  ></ng-container>
                </ng-container>
              </tbody>
            </table>

            <div
              *ngIf="!getLeafChildren(node).length"
              class="group-pagination group-pagination--nested"
            >
              <div class="group-pagination__left">
                <span>Item per page</span>
                <select
                  class="page-size-select"
                  [ngModel]="
                    getPageSizeSelectValue(
                      getNodePagination(node)?.page_size,
                      20
                    )
                  "
                  (ngModelChange)="changeGroupPage(node, 1, +($event || 20))"
                >
                  <option *ngFor="let size of pageSizeOptions" [value]="size">
                    {{ size }}
                  </option>
                </select>

                <span>{{ getPageRange(node) }}</span>
              </div>

              <div class="custom-paginator">
                <button
                  type="button"
                  class="custom-btn"
                  [disabled]="(getNodePagination(node)?.page ?? 1) <= 1"
                  (click)="
                    changeGroupPage(
                      node,
                      (getNodePagination(node)?.page ?? 1) - 1
                    )
                  "
                >
                  <i class="pi pi-chevron-left"></i>
                </button>

                <span>Page</span>

                <input
                  type="number"
                  class="page-input"
                  [value]="getNodePagination(node)?.page ?? 1"
                  (change)="
                    changeGroupPage(node, +($any($event.target).value || 1))
                  "
                  [min]="1"
                  [max]="getNodePagination(node)?.total_pages ?? 1"
                />

                <span>of {{ getNodePagination(node)?.total_pages ?? 1 }}</span>

                <button
                  type="button"
                  class="custom-btn"
                  [disabled]="
                    (getNodePagination(node)?.page ?? 1) >=
                    (getNodePagination(node)?.total_pages ?? 1)
                  "
                  (click)="
                    changeGroupPage(
                      node,
                      (getNodePagination(node)?.page ?? 1) + 1
                    )
                  "
                >
                  <i class="pi pi-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Leaf Children Experiment List -->
            <ng-container *ngIf="shouldRenderLeafExperimentList(node)">
              <app-experiment-list
                [tableColumns]="tableColumns"
                [tableData]="getLeafItemRows(node)"
                [statusOptions]="statusOptions"
                [showToggleAll]="false"
                [showPagination]="true"
                [pageSize]="getNodePagination(node)?.page_size ?? 20"
                [currentPage]="getNodePagination(node)?.page ?? 1"
                [totalPages]="getNodePagination(node)?.total_pages ?? 1"
                [totalItems]="getNodePagination(node)?.total ?? 0"
                [dragDropEnabled]="false"
                [isHeaderHide]="true"
                [showAccordion]="true"
                [accordionTemplate]="accordionTemplate"
                [sibilingTableColSpan]="10"
                [hasGroupBy]="true"
                [enableCreatedByColumn]="enableCreatedByColumn"
                (rowCheckboxChange)="handleNestedRowCheckboxChange($event)"
                (emitTableAction)="
                  handleNestedExperimentListAction($event, node)
                "
              ></app-experiment-list>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <!-- Root Group Rows -->
    <ng-container *ngFor="let root of treeData; trackBy: trackRowKey">
      <ng-container
        *ngTemplateOutlet="groupRow; context: { $implicit: root, level: 0 }"
      ></ng-container>
    </ng-container>
  </tbody>
</table>

<!-- Root Pagination -->
<div class="group-pagination">
  <div class="group-pagination__left">
    <span>Item per page</span>
    <select
      class="page-size-select"
      [ngModel]="getPageSizeSelectValue(groupsData?.page_size, 20)"
      (ngModelChange)="changeGroupPage(null, 1, +($event || 20))"
    >
      <option *ngFor="let size of pageSizeOptions" [value]="size">
        {{ size }}
      </option>
    </select>

    <span>{{ getPageRange(groupsData) }}</span>
  </div>

  <div class="custom-paginator">
    <button
      type="button"
      class="custom-btn"
      [disabled]="(groupsData?.page ?? 1) <= 1"
      (click)="changeGroupPage(null, (groupsData?.page ?? 1) - 1)"
    >
      <i class="pi pi-chevron-left"></i>
    </button>

    <span>Page</span>

    <input
      type="number"
      class="page-input"
      [value]="groupsData?.page ?? 1"
      (change)="changeGroupPage(null, +($any($event.target).value || 1))"
      [min]="1"
      [max]="groupsData?.total_pages ?? 1"
    />

    <span>of {{ groupsData?.total_pages ?? 1 }}</span>

    <button
      type="button"
      class="custom-btn"
      [disabled]="(groupsData?.page ?? 1) >= (groupsData?.total_pages ?? 1)"
      (click)="changeGroupPage(null, (groupsData?.page ?? 1) + 1)"
    >
      <i class="pi pi-chevron-right"></i>
    </button>
  </div>
</div>

<!-- Action Dropdown -->
<p-overlayPanel styleClass="option-dropdown" #dropdown appendTo="body">
  <ng-template pTemplate>
    <div class="container studio-dropdown-wrapper">
      <ng-container *ngFor="let option of actionColumnList">
        <div
          class="dropdown-option py-1 cursor-pointer {{ option.key }}"
          (click)="!option.disable && experimentAction(option); dropdown.hide()"
          [ngClass]="{
            'opacity-50 pointer-events-none cursor-not-allowed': option.disable,
          }"
          *ngIf="
            option?.disabledKey
              ? !option?.disabledValue?.includes(
                  overlayDetails[option?.disabledKey]
                )
              : true
          "
        >
          {{ option.label }}
        </div>
      </ng-container>
    </div>
  </ng-template>
</p-overlayPanel>
